import Vue from 'vue'

import { AuthController } from "../controllers/imp/auth"

Vue.use({
    install(vue) {
        Vue.prototype.initialise_auth = function (vueCtx) {
            AuthController.setApp(vueCtx)
        }

        vue.prototype.verify_login = async function () {
            let loginValid = await AuthController.verifyLogin();
            return loginValid;
        }
    }
})

